import Reveal from "@/components/feature/Reveal";
import { compareList } from "@/mocks/homeContent";

export default function CompareSection() {
  return (
    <section id="compare" className="border-y border-background-200/70 bg-secondary-50/60">
      <div className="mx-auto w-full max-w-page px-4 py-12 md:px-8 md:py-16">
        <Reveal>
          <div className="max-w-2xl">
            <h2 className="font-heading text-2xl font-semibold text-foreground-950 md:text-[30px]">
              前后对比，一眼看完变化
            </h2>
            <p className="mt-2 text-sm leading-relaxed text-foreground-600 md:text-base">
              同一件事，开播前的说法和现在的说法常常不是一个版本。左右一放，风向怎么变的就很清楚了。
            </p>
          </div>
        </Reveal>

        <div className="mt-8 grid grid-cols-1 gap-5 md:grid-cols-3 md:gap-6">
          {compareList.map((item, index) => (
            <Reveal key={item.id} delay={index * 90}>
              <article className="flex h-full flex-col rounded-lg border border-background-200 bg-background-50 p-5 md:p-6">
                <h3 className="font-heading text-lg font-semibold text-foreground-950">{item.topic}</h3>

                <div className="mt-4 flex flex-col gap-3">
                  <div className="rounded-md border border-background-200 bg-background-100/70 p-3.5">
                    <span className="inline-flex items-center gap-1.5 text-xs text-foreground-500">
                      <span className="flex h-3.5 w-3.5 items-center justify-center">
                        <i className="ri-arrow-left-down-line text-sm" />
                      </span>
                      爆料前
                    </span>
                    <p className="mt-2 text-sm leading-relaxed text-foreground-700">{item.before}</p>
                  </div>

                  <div className="rounded-md border border-accent-200 bg-accent-50 p-3.5">
                    <span className="inline-flex items-center gap-1.5 text-xs text-accent-700">
                      <span className="flex h-3.5 w-3.5 items-center justify-center">
                        <i className="ri-arrow-right-up-line text-sm" />
                      </span>
                      现在
                    </span>
                    <p className="mt-2 text-sm leading-relaxed text-foreground-800">{item.after}</p>
                  </div>
                </div>

                <p className="mt-auto pt-4 text-xs text-foreground-500">{item.heat}</p>
              </article>
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
}